'use client';

import { createContext, useContext } from 'react';
import { AuthUser } from '../modules/auth/types/auth';
import { Profile } from '@/profile';

export type AuthContextType = {
  user: AuthUser | null;
  profile: Profile | null;
  authenticate?: (credentials: { email: string; password: string }) => Promise<void>;
  logout?: () => Promise<void>;
  hydrated: boolean;
};

export const AuthContext = createContext<AuthContextType>({
  user: null,
  profile: null,
  hydrated: false,
});

export const useServerAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useServerAuth deve essere usato all’interno di un AuthProvider');
  }
  return context;
};
